export const CALENDLY_CSS_HREF = 'https://assets.calendly.com/assets/external/widget.css';

export const CALENDLY_SCRIPT_SRC = 'https://assets.calendly.com/assets/external/widget.js';

export const CALENDLY_URL = 'https://calendly.com';

export const CALENDLY_API_URL = 'https://api.calendly.com';
